module["exports"] = {
  "adjective": [
    "Pequeno",
    "Ergonómico",
    "Rústico",
    "Inteligente",
    "Linda",
    "Incrível",
    "Fantástico",
    "Prático",
    "Lustroso",
    "Impressionante",
    "Genérico",
    "Artesanal",
    "Feito à Mão",
    "Licenciado",
    "Refinado",
    "Sem Marca",
    "Saboroso"
  ],
  "material": [
    "Aço",
    "Madeira",
    "Betão",
    "Plástico",
    "Algodão",
    "Granito",
    "Borracha",
    "Metal",
    "Suave",
    "Fresco",
    "Congelado"
  ],
  "product": [
    "Cadeira",
    "Carro",
    "Computador",
    "Teclado",
    "Rato",
    "Bicicleta",
    "Bola",
    "Luvas",
    "Calças",
    "Camisa",
    "Mesa",
    "Sapatos",
    "Chapéu",
    "Toalhas",
    "Sabonete",
    "Atum",
    "Frango",
    "Peixe",
    "Queijo",
    "Bacon",
    "Pizza",
    "Salada",
    "Salsichas",
    "Batatas Fritas"
  ]
};
